var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9232 0.890137C15.9597 0.890137 18 3.02167 18 6.19386V13.5864C18 16.7586 15.9597 18.8901 12.9232 18.8901H5.07684C2.04028 18.8901 0 16.7586 0 13.5864V6.19386C0 3.02167 2.04028 0.890137 5.07684 0.890137H12.9232ZM12.9232 2.14595H5.07684C2.75609 2.14595 1.25581 3.73414 1.25581 6.19386V13.5864C1.25581 16.0461 2.75609 17.6343 5.07684 17.6343H12.9232C15.2447 17.6343 16.7442 16.0461 16.7442 13.5864V6.19386C16.7442 3.73414 15.2447 2.14595 12.9232 2.14595ZM5.12464 7.75735C5.47125 7.75735 5.75255 8.03865 5.75255 8.38525V14.1285C5.75255 14.4751 5.47125 14.7564 5.12464 14.7564C4.77804 14.7564 4.49673 14.4751 4.49673 14.1285V8.38525C4.49673 8.03865 4.77804 7.75735 5.12464 7.75735ZM9.0319 5.00795C9.3785 5.00795 9.6598 5.28925 9.6598 5.63586V14.1277C9.6598 14.4743 9.3785 14.7556 9.0319 14.7556C8.68529 14.7556 8.40399 14.4743 8.40399 14.1277V5.63586C8.40399 5.28925 8.68529 5.00795 9.0319 5.00795ZM12.8749 10.7922C13.2215 10.7922 13.5028 11.0735 13.5028 11.4201V14.1277C13.5028 14.4743 13.2215 14.7556 12.8749 14.7556C12.5283 14.7556 12.247 14.4743 12.247 14.1277V11.4201C12.247 11.0735 12.5283 10.7922 12.8749 10.7922Z",
    fill: "#5D5D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.a3d9d126d74ef8a9dc5f175ab829f98c.svg";
export { ForwardRef as ReactComponent };